import * as types from './types';

export default {
    [types.LOGIN_SUCCESS](data) {
        console.log('logim success mutation : ', data);
        Object.assign(this, data);
    }
};
